
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Quels sont ses points faibles?`}</em></p>
    <p>{`Ce vaccin a fait l'objet de plusieurs polémiques, créant aussi la méfiance du
public. On peut mentionner les craintes de `}<a parentName="p" {...{
        "href": "236700046559"
      }}>{`thrombose`}</a>{` suite à
l'injection (lire dans la catégorie "quels sont les effets secondaires?").
L'Union européenne a aussi reproché à AstraZeneca la lenteur des livraisons.
Deux plaintes ont été déposées par sa Commission. Finalement, un accord a été
conclu en septembre 2021 sur l'approvisionnement des Vingt-sept. Aux Etats-Unis,
des critiques ont été émises face aux données d'efficacité publiées à mi-mars.`}</p>
    <p>{`Signe de cette perte de confiance, le quotidien français "Le Parisien" titrait
le 9 juin 2021: "Comment AstraZeneca est passé de 50% à moins de 1% des
primo-injections quotidiennes". Le journal y note que "ce vaccin, administré à
plus de 4 millions de Français n'est désormais quasiment plus utilisé que pour
les deuxièmes injections".`}</p>
    <p>{`L'efficacité de ce produit contre les variants fait également débat. Le 8
février 2021, `}<a parentName="p" {...{
        "href": "723137982233"
      }}>{`l’Afrique du Sud`}</a>{` a annoncé qu’elle suspendait son
programme de vaccination suite à une étude révélant des résultats limités pour
prévenir les infections avec le nouveau variant circulant dans ce pays. La
protection contre les complications, elle, serait conservée.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;